import { call, put, all } from "redux-saga/effects";
import { forgottenPasswordResetAPI } from "../api/ForgottenPasswordCall";
import { reportError, reportSuccess } from "../actions/erroractions";
import {
  forgottenPasswordResetFailure,
  forgottenPasswordResetSuccess,
} from "../actions/forgottenpasswordactions";
import { moveToLoginPage } from "../actions/routeactions";

export function* forgottenPasswordResetSaga(action) {
  try {
    const result = yield call(forgottenPasswordResetAPI, action);

    if (result.ok) {
      yield all([
        put(forgottenPasswordResetSuccess()),
        put(moveToLoginPage()),
        put(reportSuccess("Password updated")),
      ]);
    } else {
      yield all([
        put(forgottenPasswordResetFailure()),
        put(reportError(result.message)),
      ]);
    }
  } catch (e) {
    yield all([
      put(reportError("Unable to reach server")),
      put(forgottenPasswordResetFailure()),
    ]);
  }
}
